/**
 * Created by Ning Jiang on 3/15/2017.
 */

import {IServerData} from "@nolimitcity/slot-game/bin/core/server/data/IServerData";
import {SpinServerDataParser} from "@nolimitcity/slot-game/bin/game/reel/spinreel/SpinServerDataParser";

export class TeslaServerDataParser extends SpinServerDataParser {

    constructor() {
        super();
    }

    public parseBonusSymbolTriggered(rawData:any):boolean {
        return rawData.bonusSymbolTriggered;
    }

    public parseWildSymbol(rawData:any):string {
        return rawData.wildSymbol;
    }

    public parseTotalSpinWinnings(rawData:any):number {
        return rawData.totalSpinWinnings;
    }

    public parseExtraFreespinRewarded(rawData:any):number {
        return rawData.extraFreespinRewarded;
    }

    public parseFreespinsPlayed(rawData:any):number {
        return rawData.freespinsPlayed;
    }

    public parseWildsCollected(rawData:any):[number] {
        return rawData.wildsCollected;
    }

    public parseRemainingFreespins(rawData:any):number {
        return rawData.remainingFreespins;
    }

    public overlayWildsBeforeSpinStop(rawData:any):boolean[][] {
        return rawData.overlayWildsBeforeSpinStop;
    }

    parseFreespinsLeft(rawData:IServerData):number | any {
        if(rawData && rawData.freespinsLeft) {
            return rawData.freespinsLeft;
        }
        return this.parseRemainingFreespins(rawData);
    }

    public parseDischargeWild(rawData:any):boolean {
        return rawData.dischargeWild;
    }
}